import { get } from '../../../utils/object-helpers';

export default function confidence(resp) {
    if (resp.confidence) {
        return {
            iconName: get(resp.confidence, 'icon.name', null),
            title: get(resp.confidence, 'title.textSpans.0.text', ''),
            body: get(resp.confidence, 'dataItems.0.textSpans.0.text', '')
        };
    }
}
